// Generated by `npm run data:coral-species` (scripts/data/coralSpecies.ts) from the NCRMP extract in
// data/ncrmp-coral-demography/. Do not edit by hand: change the script and run it. tests/coralSpecies.test.ts builds it
// again and fails if this file is not what the archive gives.

/** The user's four corals, as the Reef draws them. */
export type KitCoral = 'lobe' | 'finger' | 'rice' | 'cauliflower';
/** The Reef's surfaces a colony grows on. */
export type Surface = 'framework' | 'pavement' | 'basalt';

/**
 * NOAA's adult corals at Maui, Molokaʻi, Lānaʻi and Kahoʻolawe, 2013 to 2024, of the user's four (M169): 16319
 * colonies counted on the forereef's stratified random sites (Ecosystem Sciences Division, Pacific Islands Fisheries
 * Science Center (2024), NCRMP coral demographic data, NCEI Accession 0298217, https://doi.org/10.25921/5qsa-z057; the
 * subset `scripts/data/coralSpecies.ts` names). Each coral's colonies by stratum (`stratumIndex` order), by the
 * site's surface (`SURFACES` there), and its lengths at each twentieth of their spread, cm. MEASURED by the script.
 * Drawn, never simulated: which coral the Reef's gardens grow where, and how large.
 */
export const CORAL_SPECIES: {
  readonly strata: readonly Readonly<Record<KitCoral, number>>[];
  readonly surfaces: Readonly<Record<Surface, Readonly<Record<KitCoral, number>>>>;
  readonly lengthsCm: Readonly<Record<KitCoral, readonly number[]>>;
} = {
  strata: [
    { lobe: 824, finger: 175, rice: 408, cauliflower: 191 },
    { lobe: 944, finger: 318, rice: 552, cauliflower: 499 },
    { lobe: 362, finger: 189, rice: 421, cauliflower: 94 },
    { lobe: 310, finger: 107, rice: 270, cauliflower: 319 },
    { lobe: 403, finger: 133, rice: 601, cauliflower: 293 },
    { lobe: 242, finger: 176, rice: 420, cauliflower: 104 },
    { lobe: 1010, finger: 69, rice: 158, cauliflower: 571 },
    { lobe: 1039, finger: 485, rice: 891, cauliflower: 199 },
    { lobe: 310, finger: 172, rice: 208, cauliflower: 54 },
    { lobe: 443, finger: 28, rice: 111, cauliflower: 286 },
    { lobe: 721, finger: 220, rice: 441, cauliflower: 139 },
    { lobe: 127, finger: 11, rice: 224, cauliflower: 47 },
  ],
  surfaces: {
    framework: { lobe: 3603, finger: 1964, rice: 4268, cauliflower: 1130 },
    pavement: { lobe: 593, finger: 23, rice: 221, cauliflower: 367 },
    basalt: { lobe: 2288, finger: 74, rice: 152, cauliflower: 1244 },
  },
  lengthsCm: {
    lobe: [5, 5, 6, 7, 7, 8, 9, 10, 11, 12, 13, 15, 16, 18, 20, 23, 25.9, 30, 36, 50, 220],
    finger: [5, 6.5, 8, 10, 10.5, 12, 13.5, 15, 16.5, 19, 21, 23, 25, 28, 31, 35, 41, 49.5, 60, 85, 1729.3],
    rice: [5, 5.5, 6.8, 7, 8, 9.1, 10, 11.6, 12, 14, 15, 17, 19, 22, 25, 28, 31.4, 36.5, 45, 60, 1262.6],
    cauliflower: [5, 5.2, 6, 7, 7.6, 8.5, 9.8, 10.6, 12, 13, 14, 15, 16.7, 18, 20, 21, 23, 25, 28, 32, 63],
  },
};
